export default "__VITE_ASSET__BaGWZ8$d__"